import {
  direction as directionFromContent,
  directionFromString,
} from "@frontend-shared/lib";
import type {
  EDirection,
  IGetAutoDirectionProps,
  TAutoDirection,
} from "@frontend-shared/types";

import i18n from "@/i18n";

export const direction = (value: string): EDirection => {
  return directionFromContent({
    value,
    fallback: directionFromString(i18n.dir()),
  });
};

export const getAutoDirection = (
  props?: IGetAutoDirectionProps,
): TAutoDirection => {
  if (props?.isDisabled) return directionFromString(i18n.dir());
  if (props?.content)
    return directionFromContent({
      value: props.content,
      fallback: directionFromString(i18n.dir()),
    });
  return "auto";
};
